import { IImportVO } from 'library/ts/interfaces/importer/IImportVO';
import { IPromiseResolveGeneric } from 'library/ts/interfaces/IPromiseResolveGeneric';
import { IPlayerAdapter } from 'library/ts/player/adapter/IPlayerAdapter';
import { IPlayerAdapterAPI } from 'library/ts/player/adapter/IPlayerAdapterAPI';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';

/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Abstract player adapter class.
 * <p>Contains properties and methods common for all adapters but are falling out of AbstractClass scope</p>
 */
export class AbstractAdapter extends AbstractTagClass implements IPlayerAdapter {

	// container var for player instance
	#player: IPlayerAdapterAPI | undefined;

	constructor( argument: ITagAbstractClassArgument ) {
		super( argument );
	}

	/**
	 * @description Instance of player
	 * @type {any}
	 */
	get player(): IPlayerAdapterAPI | undefined {
		return this.#player;
	}

	set player( value: IPlayerAdapterAPI | undefined ) {
		this.#player = value;
	}

	/**
	 * @description Imports video player dependencies (JS, CSS, etc.)
	 * @param {IImportVO[]} imports
	 * @returns {Promise<IPromiseResolveGeneric & {imports: IImportVO[]}>}
	 */
	importDependencies = ( imports?: IImportVO[] ): Promise<IPromiseResolveGeneric & { imports: IImportVO[] }> => {
		return new Promise(
			( resolve, reject ) => {
				this.utils.Importer.import( imports, true ).then(
					( data ) => {
						// resolve the promise
						resolve( { msg: 'Done!', success: true, imports: data.imports } );
					}
				).catch(
					( data ) => {
						// reject the promise
						reject( { msg: 'Dependencies import error!', success: false, imports: data.imports } );
					}
				);
			}
		);
	};
}